import { render, staticRenderFns } from "./group-company.vue?vue&type=template&id=a13daf9c&scoped=true&"
import script from "./group-company.vue?vue&type=script&lang=js&"
export * from "./group-company.vue?vue&type=script&lang=js&"
import style0 from "./group-company.vue?vue&type=style&index=0&id=a13daf9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13daf9c",
  null
  
)

export default component.exports